import React, { useState } from 'react';
import './header.css';
import Button from '@mui/material/Button';
import LoginIcon from '@mui/icons-material/Login';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

function Header({ sections }) {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);


  const navLinks = [
    { id: sections.homePage, label: "home" },
    { id: "#", label: "about" },
    { id: sections.property, label: "services" },
    { id: sections.list, label: "blog" },
    { id: sections.agent, label: "pricing" },
    { id: sections.contact, label: "contact" },
  ];

  return (
    <header className="headernavbare paddings">
      <img src="/images/logo.png" width={120} alt="Logo" />

      <nav className={`navbar-wrapper ${isNavbarOpen ? 'open' : ''}`}>
        <ul className="navbar-links">
          <CloseIcon id="closeIcon" onClick={() => setIsNavbarOpen(false)} />
          {navLinks.map((link, i) => (
            <li key={i}>
              <a href={link.id === "#" ? "#" : `#${link.id}`} onClick={() => setIsNavbarOpen(false)}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="buttonContainer">
          <h1><span>2</span>List</h1>
          <Button startIcon={<LoginIcon />} variant="contained" disableElevation>
            Sign In
          </Button>
        </div>
      </nav>

      <MenuIcon id="menuIcon" onClick={() => setIsNavbarOpen(true)} className="menu-toggle" />
    </header>
  );
}

export default Header;
